import CTNTable from '@ctn/ui/components/ctn-table';
import classNames from 'classnames';
import { useMemo } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { generatePath, useNavigate, useParams } from 'react-router-dom';

import useRouteTramite from '@/hooks/useRouteTramite';

import type { IDocumento, IRepresentante } from '@/interfaces/model/don.interface';
import { findID } from '@/utils/id';

import { getColumns } from './columns';
import { type SujetoForm } from '../Interviniente/config';

type RepresentanteListadoProps = {
	readonly onEdit?: (data: IRepresentante) => void;
	readonly idPersonaJuridica?: number;
	readonly className?: string;
	readonly isDisplay?: boolean;
};

const RepresentanteListado = ({ onEdit, className, idPersonaJuridica, isDisplay }: RepresentanteListadoProps) => {
	const classNameListado = useMemo(() => classNames('c-pnp-table', className), [className]);
	const ROUTES_TRAMITE = useRouteTramite();
	const { watch, control } = useFormContext<SujetoForm>();
	const { remove } = useFieldArray({
		control,
		name: 'representantes',
	});
	const navigate = useNavigate();

	const { idTramite, idSujeto } = useParams();	

	const { representantes = [] } = watch();

	const onDelete = ({ id, idReact }: IRepresentante) => {
		const index = findID({ list: representantes, idReact, id });
		remove(index);
	};

	const onViewDocumento = (value: IDocumento, idRepresentante: number) => {
		const path = generatePath(ROUTES_TRAMITE.DETALLE_DOCUMENTO, {
			idTramite,
			idDocumento: value.id,
		});

		navigate(path, { state: { representante: true, idRepresentante, idPersonaJuridica: idSujeto ?? idPersonaJuridica } });
	};

	return (
		<CTNTable
			idData="id"
			loading={false}
			loadingConf={{ spinner: true }}
			className={classNameListado}
			columns={getColumns(
				isDisplay ? { isDisplay: true, verDocumento: onViewDocumento } : { onEdit, onDelete, isDisplay: false },
			)}
			data={representantes}
			totalData={representantes.length}
			noDataConf={{ description: 'Aún no has añadido ningún representante' }}
			pageSize={100}
		/>
	);
};

export default RepresentanteListado;
